module.exports = __webpack_public_path__ + "static/img/h-04.978117d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-04.png
// module id = tanN
// module chunks = 1